let SockJS
export async function init() {
  await import(/* webpackChunkName: "sockjs" */ './sockjs.js').then(module => {
    SockJS = module.default
  })
  await import(/* webpackChunkName: "sockjs" */ './stomp.js')
}

let stompClient = null
function toWsBase(url) {
  return url.replace(/^https:\/\//, 'wss://').replace(/^http:\/\//, 'ws://')
}
function startConnet(options = {}) {
  console.log(options, 'startConnet')
  if (!options.auth || !options.url) {
    return Promise.resolve(false)
  }

  disconnect()

  const socket = new SockJS(options.url)
  stompClient = Stomp.over(socket)

  const timeoutMs = Number(options.timeoutMs) || 5000
  const disconnectOnTimeout = options.disconnectOnTimeout !== false
  let settled = false

  return new Promise(resolve => {
    const settle = result => {
      if (settled) return
      settled = true
      resolve(result)
    }

    const timerId = setTimeout(() => {
      if (settled) return
      const err = new Error('SockJS connect timeout')
      try {
        options.onError && options.onError(err)
      } catch (e) {}
      if (disconnectOnTimeout) disconnect()
      settle(false)
    }, timeoutMs)

    const headers = { ...(options.headers || {}) }
    if (headers.Authorization == null) headers.Authorization = options.auth
    if (
      headers.host == null &&
      typeof window !== 'undefined' &&
      window.location &&
      window.location.host
    ) {
      headers.host = window.location.host
    }

    stompClient.connect(
      headers,
      function (frame) {
        clearTimeout(timerId)

        if (!stompClient) {
          const err = new Error('SockJS client lost')
          try {
            options.onError && options.onError(err)
          } finally {
            settle(false)
          }
          return
        }

        try {
          options.onConnect && options.onConnect(frame)
        } catch (e) {}

        if (options.path) {
          stompClient.subscribe(options.path, function (response) {
            let data = response?.body
            try {
              data = JSON.parse(response.body)
            } catch (e) {}
            options.onResponse && options.onResponse(data)
          })
        }

        settle(true)
      },
      function (err) {
        clearTimeout(timerId)
        try {
          options.onError && options.onError(err)
        } finally {
          disconnect()
          settle(false)
        }
      }
    )
  })
}

//关闭双通道
function disconnect() {
  if (stompClient != null) {
    try {
      stompClient.disconnect()
    } catch (e) {}
    stompClient = null
    console.log('Disconnected')
  }
}

export default {
  init,
  startConnet,
  disconnect
}
